import React, { useState, useEffect } from "react";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import Parser from "html-react-parser";
import Meta from "@components/Meta/Meta";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";
import CardTypeFolder from "@components/CardTypeFolder/CardTypeFolder";
import useMediaQuery from "app/hooks/useMediaQuery";

import "./AhorrosInfo.css";

const ROOT = process.env.REACT_APP_CMS_STATIC;

const AhorrosInfo = ({ ahorro, borderTopColor, ...props }) => {
  const [meta, setMeta] = useState({});
  const [itemsBreadcrumb, setItemsBreadcrumb] = useState([]);
  const [detailTitleStyle, setDetailTitleStyle] = useState({
    minWidth: "225px",
    maxWidth: "75%",
    width: "fit-content",
  });
  const [btnSolicite, setBtnSolicite] = useState({});

  const isDesktop = useMediaQuery("(min-width: 992px)");
  const isIpadPortrait = useMediaQuery("(max-width: 992px)");
  const isIphoneLandscape = useMediaQuery("(max-width: 576px)");

  const getWidthTitle = () => {
    if (isIphoneLandscape) {
      setDetailTitleStyle({
        minWidth: "178",
        maxWidth: "100%",
        width: "fit-content",
      });
    } else if (isIpadPortrait || isIphoneLandscape) {
      setDetailTitleStyle({
        minWidth: "225px",
        maxWidth: "75%",
        width: "fit-content",
      });
    }
  };

  useEffect(() => {
    if (!isEmpty(ahorro.btnSolicite)) {
      setBtnSolicite({
        url: ahorro.btnSolicite.url,
        alt: ahorro.btnSolicite.alt,
        img: ROOT + ahorro.btnSolicite.image.imagen.urls[0],
      });
    }
    getWidthTitle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDesktop, isIpadPortrait, isIphoneLandscape, ahorro.btnSolicite]);

  useEffect(() => {
    if (!isEmpty(ahorro)) {
      setMeta((m) => {
        return {
          ...m,
          title: ahorro.title,
          description: ahorro.description,
          url: `/${ahorro.id}`,
        };
      });

      if (ahorro.prevRoute) {
        setItemsBreadcrumb([
          {
            url: ahorro.prevRoute[0].url,
            text: ahorro.prevRoute[0].text,
          },
        ]);
      } else {
        setItemsBreadcrumb([{ url: `${ahorro.id}`, text: ahorro.title }]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ahorro]);

  const button = (
    <div className="w-100">
      <div className="button-container">
        {!isEmpty(btnSolicite) && (
          <div className="cmsButton">
            <a
              className="anchor"
              href={btnSolicite.url}
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="img"
                src={btnSolicite.img}
                alt={btnSolicite.alt}
              />
            </a>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <>
      <Meta
        title={meta?.title + " | Plan de Ahorro | CS Ahorro y Crédito Costa Rica"}
        description={meta?.description}
        canonicalUrl={meta?.url}
      />
      <Breadcrumbs items={itemsBreadcrumb} active={ahorro?.title} />
      <div className="ahorro-container">
        <div className="w-100 d-flex flex-column align-items-start text-left">
          <h1 className="ahorro-title">{ahorro.title}</h1>
          <span className="ahorro-description">
            {Parser(ahorro.description)}
          </span>
        </div>
        <div className="w-100">
          {ahorro.details &&
            ahorro.details.map((detail, index) => (
              <CardTypeFolder
                key={index}
                titleStyle={detailTitleStyle}
                title={detail.title}
                description={detail.description.html}
                borderTopColor={borderTopColor}
              />
            ))}
        </div>
        {button}
      </div>
    </>
  );
};

AhorrosInfo.propTypes = {
  ahorro: PropTypes.object.isRequired,
  borderTopColor: PropTypes.string,
};

export default AhorrosInfo;
